export { default as UnderstandingYourResultsPage } from "./understandingYourResults";
